export const payDetailModel = (id) => ({
    id: id,
    dtId: null,
    docId: null,
    payId: null,
    recDtId: null,
    recId: null,
    line: null,
    itemId: null,
    recNo: null,
    itemCode: null,
    itemName: null,
    itemQty: null,
    itemOldQty: null,
    itemUnit: null,
    itemPriceUnit: null,
    itemDiscount: null,
    itemDisType: null,
    itemTotal: null,
    itemStatus: null,
    whId: null,
    zoneId: null,
    ltId: null,
    dsSeq: null,
    itemDesc: null
});